// extracted by mini-css-extract-plugin
module.exports = {"header":"ProfileContentTemplate_header__KtsaS","content":"ProfileContentTemplate_content__1_GJ-","sending":"ProfileContentTemplate_sending__11aic"};